<template>
  <v-dialog v-model="dialog" persistent max-width="1000px" content-class="report-error-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Missing Parameters</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card flat>
          <v-card-text>
            <div class="mb-4 mt-2">
              The following missing parameters could not be matched to existing data. <br />
              This can happen if data is modified. One common example is if the analyte is updated or merged.
              Please let us know so we can fix this for you.
            </div>

            <div class="subheading font-weight-medium mb-2">Missing Parameters</div>
            <div>
              <TreeView :data="{ value: missingParams }" />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <v-spacer />
            <v-btn @click="clearMissingParams()" color="warning">
              {{$t('Button.RemoveMissingParameters')}}
            </v-btn>
            <v-btn color="secondary" outline @click="close()">{{$t('Button.Close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
    }),
    computed: {
      missingParams() {
        return this.$store.getters['multistation/missingParams']
      },
    },
    methods: {
      show() {
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
      async clearMissingParams() {
        await this.$store.dispatch('multistation/clearMissingParams')
        this.$emit('mustSaveMissingParams')
        this.close()
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>

<style>
  .report-error-dialog {
    display: flex;
    flex-direction: column;
  }
</style>